import React, { useEffect, useRef } from "react";
import { Card } from "react-bootstrap";
import QRCodeStyling from "qr-code-styling";
import logo from "../Assets/Images/cleir_logo.png";
import VocabQRWithLogo from "../ConfigFiles/multilingual/VocabQRWithLogo";

export default function QRWithLogo({ size = 400, data = "https://default-link.com", message, lan }) {
  const ref = useRef(null);
  const qr = useRef(null);

  // create the QRCodeStyling instance once on mount
  useEffect(() => {
    qr.current = new QRCodeStyling({
      width: size,
      height: size,
      type: "svg",
      data,
      image: logo,
      dotsOptions: {
        color: "#000",
        type: "rounded"
      },
      backgroundOptions: {
        color: "#fff"
      },
      imageOptions: {
        margin: 10
      }
    });

    if (ref.current) qr.current.append(ref.current);

    return () => {
      // cleanup DOM when component unmounts
      if (ref.current) ref.current.innerHTML = "";
      qr.current = null;
    };
  }, []); // run once on mount

  // update the QR instance when props change
  useEffect(() => {
    if (!qr.current) return;
    qr.current.update({
      width: size,
      height: size,
      data,
      image: logo
    });
  }, [size, data, logo]);

  return (
    <Card className="p-3 shadow text-center">
      <h4>{message}</h4>
      <div ref={ref} />
      <p className="mt-3">
        {VocabQRWithLogo.cant_see[lan]}
        <br/>
        <a href={data} target="_blank" rel="noopener noreferrer">
          {data}
        </a>
      </p>
    </Card>
  );
}
